import type {
  CompletionAttributeCondition,
  CustomAttributes
} from 'shared-types';
import type { ReduxRootState } from 'types';

interface Params {
  attributeValue: CustomAttributes['key'];
  messages: ReduxRootState['messages'];
  references?: { expiration?: number | string; workload?: number | string };
  requirements: CompletionAttributeCondition[];
}

const composeWarning = (
  header: string,
  messages: ReduxRootState['messages'],
  value?: number | string
) => `${header}${value ? ` (${messages.commonValue}: ${value})` : ''}`;

const getCustomAttributesWarnings = ({
  attributeValue,
  messages,
  references,
  requirements = []
}: Params) => {
  const warnings: { [keyOption: string]: string[] } = {};
  if (!attributeValue || !requirements.length) return warnings;

  requirements.forEach((req) => {
    const { value } = req;

    const isMatch = Array.isArray(attributeValue)
      ? attributeValue.includes(value)
      : value === attributeValue;

    if (isMatch) {
      if (!warnings.hasOwnProperty(value)) warnings[value] = [] as string[];

      if (req.requireWorkload)
        warnings[value].push(
          composeWarning(
            messages.settingsCompletionWorkload,
            messages,
            references?.workload
          )
        );

      if (req.requireExpiration)
        warnings[value].push(
          composeWarning(
            messages.settingsCompletionExpiration,
            messages,
            references?.expiration
          )
        );
    }
  });

  return warnings;
};

export default getCustomAttributesWarnings;
